import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const CountriesPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = [{"tabId": "OverviewTab", "label": "axFormLayout.country.tabs.overviewtab", "order": 1, "groups": [{"groupId": "OverviewTab_MainFields", "label": "axFormLayout.country.groups.overviewtab.overviewtab_mainfields", "order": 1, "fields": ["countryid", "name", "type", "addrformat", "isocode"]}], "fields": []}, {"tabId": "GeneralTab", "label": "axFormLayout.country.tabs.generaltab", "order": 2, "groups": [{"groupId": "Intrastat", "label": "axFormLayout.country.groups.generaltab.intrastat", "order": 5, "fields": ["intrastatcode"]}], "fields": []}];

  const baseColumns = [
    {
      key: "countryid",
      label: "countries.countryId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "type",
      label: "countries.type",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "isocode",
      label: "countries.isocode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "addrformat",
      label: "countries.addrformat",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "name",
      label: "countries.name",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "intrastatcode",
      label: "countries.intrastatcode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "modifieddate",
      label: "countries.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "datetime",
      filterType: "date"    },
    {
      key: "dataAreaId",
      label: "countries.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: true,
    canEdit: true,
    canDelete: false
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="countries"
      permissionPrefix="legacy.countries"
      icon={faGlobe}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default CountriesPageGen;